(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Usuariolog', Usuariolog);

    Usuariolog.$inject = ['$resource', 'DateUtils'];

    function Usuariolog ($resource, DateUtils) {
        var resourceUrl =  'api/usuariologs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
